// @flow
import React, { Component } from 'react';
import { injectIntl, type IntlShape } from 'react-intl';

import type { Role, User } from 'state/types';
import { getLocalizedRoleName } from 'util/roleUtils';
import { doesUserMatchUserName, isAdminUser } from 'util/userUtils';
import { NAME_ADMIN } from 'util/roleUtils';
import localizedStrings from '../../../util/localizedStrings';

type Props = {
  onChangeRole: (User, string) => void,
  loggedInUserName: string,
  roles: Role[],
  intl: IntlShape,
  user: User,
};

class UserRolePicker extends Component<Props> {
  handleChangeRole: Function;

  constructor() {
    super();

    this.handleChangeRole = this.handleChangeRole.bind(this);
  }

  handleChangeRole(e: SyntheticMouseEvent<HTMLSelectElement>) {
    this.props.onChangeRole(this.props.user, e.currentTarget.value);
  }

  handleClick(e: SyntheticMouseEvent<HTMLSelectElement>) {
    // Don't change the selection when the user clicks the Role dropdown.
    e.stopPropagation();
  }

  isRoleReadOnly(user) {
    const { loggedInUserName } = this.props;
    return isAdminUser(user) || doesUserMatchUserName(user, loggedInUserName);
  }

  render() {
    const { intl, roles, user } = this.props;

    return (
      <div>
        {this.isRoleReadOnly(user) ? (
          <div className="is-size-7">
            {getLocalizedRoleName(intl, NAME_ADMIN)}
          </div>
        ) : (
          <div className="select is-small">
            <select
              onChange={this.handleChangeRole}
              onClick={this.handleClick}
              value={user.roleName}
              data-test-name="user-role-picker"
            >
              {/* undefined or null value is interpreted by React as an uncontrolled component */}
              <option value="">
                {intl.formatMessage(localizedStrings.NO_CATALOGS)}
              </option>
              {roles.map(role => (
                <option
                  key={role.name}
                  value={role.name}
                  data-test-name={'role-name-' + role.name}
                >
                  {getLocalizedRoleName(intl, role.name)}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(UserRolePicker);



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/UserRolePicker.js